import React, { useState, useEffect } from 'react';
import loaderIcon from '../../../assets/images/icons/loader.gif';
import pptIcon from '../../../assets/images/icons/ppt.svg';
import deleteIcon from '../../../assets/images/icons/trash.svg';
import uploadIcon from '../../../assets/images/icons/upload-cloud.svg';
import { Col, Row, Input, Radio, Space, Select, Switch } from 'antd';
import { default as ReactSelect } from 'react-select';

const CustomOption = ({ value, label }) => (
    <div className="d-flex gap-10">
        <span>{value}</span><b>{label}</b>
    </div>
);
const { Option } = Select;

const options = [
    { value: 'USA', label: '+1' },
    { value: 'Pakistan', label: '+92' },
    { value: 'Germany', label: '+49' },
    { value: 'Kenya', label: '+254' },
    { value: 'Nigeria', label: '+234' },
];


const codeOptions = [
    { value: 'USA', label: '+1' },
    { value: 'Pakistan', label: '+92' },
    { value: 'Germany', label: '+49' },
    { value: 'Kenya', label: '+254' },
    { value: 'Nigeria', label: '+234' },
    { value: 'wdwdwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww', label: '+234' },
];

function OnboardingComponents() {

    React.useEffect(() => {
        setTimeout(() => {
            const reactInput = document.getElementById('react-select-2-input')
            reactInput?.setAttribute("placeholder", "Search");
        }, 1500);
    })



    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            padding: 10,
            display: 'flex',
            alignItems: 'center',
        }),
    };

    const formatOptionLabel = ({ value, label }) => (
        <div className="d-flex gap-10">
            <span>{value}</span><b>{label}</b>
        </div>
    );
    const [selectedOption, setSelectedOption] = useState(null);

    const handleChange = option => {
        setSelectedOption(option);
    };
    const [value, setValue] = useState(1);
    const onChange = (e) => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };
    const onChangeSwitch = (checked) => {
        console.log(`switch to ${checked}`);
    };
    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    }, []);

    return (
        <>

            <div className="container_box mt-5">
                <Row gutter={16} className='mb-5'>
                    <Col span={12}>
                        <div className="form_content_block--group">
                            <ReactSelect
                                value={selectedOption}
                                onChange={handleChange}
                                options={codeOptions}
                                isSearchable={true}
                                // menuIsOpen={true}
                                // className="form_select basic"
                                classNamePrefix="form_select basic"
                                formatOptionLabel={formatOptionLabel}
                                styles={customStyles}
                                placeholder=""
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className="form_content_block--group">
                            <div className='input_group'>
                                <ReactSelect
                                    value={selectedOption}
                                    onChange={handleChange}
                                    options={codeOptions}
                                    isSearchable={true}
                                    menuIsOpen={true}
                                    // className="form_select basic"
                                    classNamePrefix="form_select basic"
                                    formatOptionLabel={formatOptionLabel}
                                    styles={customStyles}
                                    placeholder=""
                                    dropdownStyle={{
                                        width: '34.4rem'
                                    }} // Set the custom width for the dropdown
                                />
                                <Input defaultValue="" className='form_control' />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={24}>
                        <div className="form_content_block--group">
                            <label for='fileUploader' className='ant_upload_drag'>
                                <p className="upload_drag_icon">
                                    <img src={uploadIcon} alt='USP' />
                                </p>
                                <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                <p className="ant_upload_hint">
                                    PPT (max. 100 MB)
                                </p>
                            </label>
                            <input className='form_upload d-none' type="file" id="fileUploader" name="fileUploader" />

                            <div class="ant_upload_list--item">
                                <div class="ant_upload_list--content">
                                    <img src={pptIcon} alt="USP" />
                                    <div class="ant_upload_list--info">
                                        <span class="ant_upload_list--info-name">84x84.jpg</span>
                                        <span class="ant_upload_list--info-size">0.01 MB</span>
                                    </div>
                                </div>
                                <button type="link" class="ant_upload_list--delete">
                                    <img src={deleteIcon} alt="USP" />
                                </button>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group position-relative">
                            <Space.Compact className='form_compact basic'>
                                <Select
                                    className='form_select'
                                    optionLabelProp="label"
                                    // open="true"
                                    dropdownStyle={{
                                        width: '34.4rem'
                                    }} // Set the custom width for the dropdown
                                >
                                    {
                                        options.map((option) => (
                                            <Option key={option.value} value={option.value} label={option.label}>
                                                <CustomOption value={option.value} label={option.label} />
                                            </Option>
                                        ))
                                    }
                                </Select>
                                <Input defaultValue="Xihu District, Hangzhou" className='form_control' />
                            </Space.Compact>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Single Select</label>
                            <Switch defaultChecked onChange={onChangeSwitch} />

                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group hide_caret_after_select_value">
                            <label className='form_label'>Single Select with no search</label>
                            <Select
                                showSearch
                                // open={true}
                                optionFilterProp="label"
                                className='form_select basic no_search'
                                options={[
                                    {
                                        value: 'one',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'tow',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'three',
                                        label: 'Loreum Ipsum',
                                    },
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Single Select</label>
                            <Radio.Group onChange={onChange} value={value}>
                                <Radio className='custom-radio' value={1}>Publisher</Radio>
                                <Radio className='custom-radio' value={2}>Publisher</Radio>
                                <Radio className='custom-radio' value={3}>Publisher</Radio>
                                <Radio className='custom-radio' value={4}>Publisher</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group hide_caret_after_select_value">
                            <label className='form_label'>Single Select</label>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                className='form_select basic'
                                options={[
                                    {
                                        value: 'one',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'tow',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'three',
                                        label: 'Loreum Ipsum',
                                    },
                                ]}
                            />
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group hide_caret_after_select_value">
                            <label className='form_label'>Single Select</label>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                className='form_select basic error'
                                options={[
                                    {
                                        value: 'one',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'tow',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'three',
                                        label: 'Loreum Ipsum',
                                    },
                                ]}
                            />
                            <span className='error_content'>Please enter valid Name</span>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group hide_caret_after_select_value">
                            <label className='form_label'>Single Select</label>

                            <Select
                                showSearch
                                optionFilterProp="label"
                                open={true}
                                className='form_select basic'
                                options={[
                                    {
                                        value: 'one',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'tow',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'three',
                                        label: 'Loreum Ipsum',
                                    },
                                ]}
                            />
                        </div>
                    </Col>
                </Row>

                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Input</label>
                            <Input
                                className='form_control basic'
                                placeholder="Enter your Full Name"
                            />
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Error</label>
                            <Input
                                className='form_control basic error'
                                placeholder="Enter your Full Name"
                            />
                            <span className='error_content'>Please enter valid Name</span>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Disabled</label>
                            <Input
                                className='form_control basic'
                                placeholder="Enter your Full Name"
                                disabled
                                value={100}
                            />
                        </div>
                    </Col>

                </Row>

                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Button Primary</label>
                            <button className='btn_primary btn'>
                                <span>SUBMIT</span>
                            </button>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Button Primary</label>
                            <button className='btn_primary btn'>
                                <span>SUBMIT</span>
                            </button>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Button Primary</label>
                            <button className='btn_primary btn' disabled>
                                <span>SUBMIT</span>
                            </button>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Button Primary</label>
                            <button className='btn_primary btn loader'>
                                <span>SUBMIT</span>
                                <img src={loaderIcon} alt='USP' className='loader_icon' />
                            </button>
                        </div>
                    </Col>
                </Row>
            </div >

        </>
    )
}

export default OnboardingComponents
